export function getEnv(key) {
  return window.__ENV__?.[key] || process.env[key];
}
